// 订单与合同：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 采购订单
export const buy = Object.freeze({
  "buyOrders.title": "My purchase orders",
  "buyOrders.orderNumber": "Order number",
  "buyOrders.productTitle": "Product",
  "buyOrders.partNumber": "Part number",
  "buyOrders.image": "Image",
  "buyOrders.quantity": "Quantity",
  "buyOrders.totalAmount": "Total amount",
  "buyOrders.status": "Order status",
  "buyOrders.time": "Time",
  "buyOrders.actions": "Actions",
  "buyOrders.review": "Write a review",
  "buyOrders.viewReview": "View review",
  "buyOrders.viewDetails": "View details",
  "buyOrders.payCommission": "Pay commission",
  "buyOrders.uploadPaymentProof": "Upload payment proof",
  "buyOrders.confirmReceipt": "Confirm receipt",
});

// 联系人
export const contact = Object.freeze({
  "contactDialog.noTags": "No tags available",
  "contactDialog.contact": "Contact person",
  "contactDialog.enterContactName": "Enter contact name",
  "contactDialog.ms": "Ms.",
  "contactDialog.mr": "Mr.",
  "contactDialog.phone": "Phone number",
  "contactDialog.enterPhone": "Enter phone number",
  "contactDialog.wechatNumber": "WeChat ID",
  "contactDialog.enterWechatNumber": "Enter WeChat ID",
  "contactDialog.hometown": "Hometown",
  "contactDialog.enterHometown": "Enter contact's hometown",
  "contactDialog.character": "Personality",
  "contactDialog.hobbies": "Hobbies",
  "contactDialog.bindNegotiator": "Assign negotiator",
  "contactDialog.searchNegotiatorNameOrPhone":
    "Search negotiator by name or phone",
  "contactDialog.setDefault": "Set as default contact",
  "contactDialog.cancel": "Cancel",
  "contactDialog.gender": "Gender",
  "contactDialog.characterShort": "Personality",
  "contactDialog.hobbiesShort": "Hobbies",
  "contactDialog.searchNegotiator": "Search negotiators",
  "contactDialog.chooseNegotiator": "Choose negotiator",
  "contactDialog.noMore": "No more results",
  "contactDialog.choosePerson": "Choose a person",
  "contactDialog.newContact": "Add contact",
  "contactDialog.changeContact": "Change contact",
  "contactDialog.choosePersonHint": "Search for a person to add",
  "contactDialog.newContactHint":
    "Add contact details for order communication and coordination",
  "contactDialog.changeContactHint":
    "Choose a contact and optionally set a default",
  "contactDialog.confirmAdd": "Add person",
  "contactDialog.confirmChange": "Confirm change",
  "contactDialog.searchPersonName": "Search by name",
  "contactDialog.searchContactNameOrPhone": "Search contact by name or phone",
  "contactDialog.noMatchingContacts": "No matching contacts",
  "contactDialog.noContactsToChange": "No contacts available to change",
  "contactDialog.noMatchingPeople": "No matching people",
  "contactDialog.searchPersonToAdd": "Enter a name to find someone to add",
  "contactDialog.supplierIdRequired": "Supplier ID is required",
  "contactDialog.unnamedPerson": "Unnamed person",
});

// 购物与谈判人
export const broker = Object.freeze({
  "mobileCart.title": "Cart",
  "mobileCart.totalPrefix": "",
  "mobileCart.totalSuffix": " items",
  "mobileCart.edit": "Edit",
  "mobileCart.selectAll": "Select all",
  "mobileCart.total": "Total:",
  "mobileCart.checkout": "Checkout ({count})",
  "mobileCart.delete": "Delete",
  "mobileCart.empty": "Your cart is empty. Explore products to get started.",
  "mobileCart.browse": "Browse products",
  "mobileBroker.notBroker": "Apply to become a negotiator to access this page",
  "mobileBroker.underReview": "Under review",
  "mobileBroker.apply": "Apply to become a negotiator",
  "mobileBroker.reviewing": "Your application is under review",
  "mobileBroker.applicationInfo": "Application details",
  "mobileBroker.shopName": "Shop name",
  "mobileBroker.shopNamePlaceholder": "Enter the shop name",
  "mobileBroker.ownerName": "Owner name",
  "mobileBroker.ownerNamePlaceholder": "Enter your legal name",
  "mobileBroker.ownerNameInvalid": "Enter a valid name",
  "mobileBroker.ownerPhone": "Owner mobile number",
  "mobileBroker.ownerPhonePlaceholder": "Enter an 11-digit mobile number",
  "mobileBroker.ownerPhoneInvalid": "Enter a valid mobile number",
  "mobileBroker.ownerWechat": "Owner WeChat ID",
  "mobileBroker.ownerWechatPlaceholder": "Enter your WeChat ID",
  "mobileBroker.ownerWechatRequired": "Enter a WeChat ID",
  "mobileBroker.reason": "Reason for applying",
  "mobileBroker.reasonPlaceholder": "Briefly describe why you are applying",
  "mobileBroker.reasonRequired": "Enter a reason for applying",
  "mobileBroker.submitting": "Submitting...",
  "mobileBroker.submit": "Submit application",
  "mobileBroker.succeeded": "Application submitted!",
  "mobileBroker.failed": "Submission failed",
  "mobileBroker.retryLater": "Submission failed. Please try again later",
});

// 移动结算
export const checkout = Object.freeze({
  "mobileCheckout.title": "Order checkout",
  "mobileCheckout.chooseAddress": "Choose a delivery address",
  "mobileCheckout.goodsTotal": "{count} items, total:",
  "mobileCheckout.orderAmount": "Order total:",
  "mobileCheckout.coupon": "Coupon:",
  "mobileCheckout.noCoupon": "No coupons available",
  "mobileCheckout.deliveryFee": "Delivery fee:",
  "mobileCheckout.chooseAddressFirst": "Choose a delivery address first",
  "mobileCheckout.paymentMethod": "Payment method",
  "mobileCheckout.balancePayment": "Pay with balance (available: ¥ {balance})",
  "mobileCheckout.buyerNotePlaceholder":
    "Optional buyer note (up to 50 characters)",
  "mobileCheckout.amountDue": "Amount due:",
  "mobileCheckout.submitOrder": "Place order",
  "mobileCheckout.paymentSuccess": "Payment successful",
});

// 移动订单组件
export const mobileComponents = Object.freeze({
  "mobileOrder.splitOrder": "Split order",
  "mobileOrder.split": "Split",
  "mobileOrder.fastOrder": "Fast order",
  "mobileOrder.mergedOrder": "Merged order",
  "mobileOrder.contractAndOrderNumbers": "Contract / order IDs",
  "mobileOrder.contractNumber": "Contract ID",
  "contractNumber.partiesRequired": "Select different buyer and seller companies first",
  "contractNumber.companyChanged": "The selected companies changed. Confirm the contract number again",
  "contractNumber.reviewFiles": "The contract number differs. Check downloaded or uploaded contract files before submitting",
  "contractNumber.unavailable": "The contract number is temporarily unavailable. Retry later or contact an administrator",
  "contractNumber.companyCodeRequired": "Add the other company’s code to its company profile first",
  "contractNumber.invalidCompanyCode": "Correct the other company’s code in its company profile first",
  "contractNumber.expired": "The contract number expired. Get a new number and check the contract files",
  "contractNumber.alreadySubmitted": "This form was already submitted. Refresh to view the original contract",
  "contractNumber.businessRequired": "Only business staff can allocate contract numbers",
  "contractNumber.purchasePending": "Generated after selecting the seller company",
  "contractNumber.salePending": "Generated after selecting the buyer company",
  "mobileOrder.orderNumber": "Order ID",
  "mobileOrder.goodsNumber": "Product ID",
  "mobileOrder.close": "Close",
  "mobileOrder.copy": "Copy",
  "mobileOrder.brand": "Brand",
  "mobileOrder.title": "Title",
  "mobileOrder.quantity": "Quantity",
  "mobileOrder.unitPrice": "Unit price",
  "mobileOrder.quantityBeforeSplit": "Quantity before split",
  "mobileOrder.contacts": "Contacts",
  "mobileOrder.details": "Details",
  "mobileOrder.collapseTradeInfo": "Hide trade details",
  "mobileOrder.moreTradeInfo": "More trade details",
  "mobileOrder.viewDetails": "View details",
  "mobileOrder.moreActions": "More actions",
  "mobileOrder.more": "More",
  "mobileOrder.inviteSeller": "Invite seller",
  "mobileOrder.generateSalesOrder": "Create sales order",
  "mobileOrder.generatePurchaseOrder": "Create purchase order",
  "mobileOrder.cancel": "Cancel",
  "mobileOrder.inspectGoods": "Inspect goods",
  "mobileOrder.inspectionDetails": "Inspection details",
  "mobileOrder.rateNow": "Leave a review",
  "mobileOrder.viewRating": "View review",
  "mobileOrder.uploadInvoice": "Upload invoice",
  "mobileOrder.confirmPaymentReceived": "Confirm payment received",
  "mobileOrder.uploadShippingInfo": "Upload shipping details",
  "mobileOrder.uploadPaymentProof": "Upload proof of payment",
  "mobileOrder.confirmDelivery": "Confirm delivery",
  "mobileOrder.company": "Company",
  "mobileOrder.callNumber": "Call {phone}",
  "mobileOrder.phone": "Phone",
  "mobileOrder.splitAction": "Split",
  "mobileOrder.revokeAction": "Revoke",
  "mobileOrder.buy": "Purchase",
  "mobileOrder.sell": "Sale",
  "mobileOrder.copySuccess": "Copied",
  "mobileOrder.copyFailed": "Could not copy",
  "mobileOrder.notice": "Notice",
  "mobileOrder.revokeSplitConfirm": "Revoke this split order?",
  "mobileOrder.confirmRevoke": "Confirm revoke",
  "mobileOrder.revokeSuccess": "Revoked",
  "mobileOrder.paymentProofRequired": "Upload proof of payment first",
  "mobileOrder.paymentProofUploaded": "Proof of payment uploaded",
  "mobileOrder.shippingAddressRequired": "Select a delivery address",
  "mobileOrder.proofOrRemarkRequired": "Upload proof or enter a remark",
  "mobileOrder.shippingInfoUploaded": "Shipping details uploaded",
  "mobileOrder.deliveryConfirmed": "Delivery confirmed",
  "mobileOrder.paymentConfirmed": "Payment receipt confirmed",
  "mobileOrder.invoiceRequired": "Upload at least one invoice",
  "mobileOrder.invoiceUploaded": "Invoice uploaded",
  "mobileOrder.filter": "Filter",
  "mobileOrder.searchAll": "Search all",
  "mobileOrder.searchName": "Search by name",
  "mobileOrder.searchPartNumber": "Search by part number",
  "mobileOrder.partNumberOrNameSearch": "Search part number or name",
  "mobileOrder.nameSearch": "Search names",
  "mobileOrder.partNumberSearch": "Search part numbers",
  "mobileOrder.invite": "Invite",
});

// 移动订单
export const mobile = Object.freeze({
  "mobileOrders.myOrders": "My orders",
  "mobileOrders.all": "All",
  "mobileOrders.awaitingPayment": "Awaiting payment",
  "mobileOrders.awaitingShipment": "Awaiting shipment",
  "mobileOrders.awaitingReceipt": "Awaiting receipt",
  "mobileOrders.awaitingReview": "Awaiting review",
  "mobileOrders.submitted": "Submitted",
  "mobileOrders.paymentSucceeded": "Payment successful",
});

// 移动购物车
export const mobileCart = Object.freeze({
  "mobileShopCart.goodsList": "Products",
  "mobileShopCart.unnamedProduct": "Unnamed product",
  "mobileShopCart.partNumber": "Part number",
  "mobileShopCart.unitPrice": "Unit price",
  "mobileShopCart.quantity": "Quantity",
  "mobileShopCart.pieceUnit": "items",
  "mobileShopCart.sellerInfo": "Seller details",
  "mobileShopCart.companyName": "Company name",
  "mobileShopCart.contactPerson": "Contact person",
  "mobileShopCart.contactPhone": "Contact phone",
  "mobileShopCart.noPendingProducts": "No products to submit",
  "mobileShopCart.estimatedTotal": "Estimated total",
  "mobileShopCart.itemCount": "{count} items",
  "mobileShopCart.finalAmountHint":
    "Final amount subject to order confirmation",
  "mobileShopCart.approximately": "Approx.",
  "mobileShopCart.buyerInfo": "Buyer information",
  "mobileShopCart.enterCompanyName": "Enter company name",
  "mobileShopCart.taxNumber": "Company tax ID",
  "mobileShopCart.enterTaxNumber": "Enter company tax ID",
  "mobileShopCart.enterContactPerson": "Enter contact person",
  "mobileShopCart.contactInfo": "Contact information",
  "mobileShopCart.enterPhone": "Enter phone number",
  "mobileShopCart.deliveryAddress": "Delivery address",
  "mobileShopCart.enterDeliveryAddress": "Enter delivery address",
  "mobileShopCart.attachments": "Attachments",
  "mobileShopCart.uploadOrderInfo": "Upload order details",
  "mobileShopCart.maxTenFiles": "Upload up to 10 files",
  "mobileShopCart.orderInfo": "Order details",
  "mobileShopCart.infoUsageHint":
    "Information is used only for this purchase inquiry",
  "mobileShopCart.submitting": "Submitting...",
  "mobileShopCart.checkoutTitle": "Submit purchase inquiry",
  "mobileShopCart.submitPurchaseIntent": "Submit inquiry",
  "mobileShopCart.loginFirst": "Please log in first",
  "mobileShopCart.submitSuccess": "Purchase inquiry submitted successfully!",
  "mobileShopCart.cartTitle": "Shopping cart",
  "mobileShopCart.done": "Done",
  "mobileShopCart.manage": "Manage",
  "mobileShopCart.searchPlaceholder": "Search product part numbers or names",
  "mobileShopCart.loading": "Loading",
  "mobileShopCart.product": "product",
  "mobileShopCart.selectProduct": "Select {product}",
  "mobileShopCart.noImage": "No image",
  "mobileShopCart.outOfStock": "Out of stock",
  "mobileShopCart.lowStock": "Low stock",
  "mobileShopCart.decreaseProductQuantity": "Decrease quantity of {product}",
  "mobileShopCart.editQuantity": "Edit quantity, currently {count}",
  "mobileShopCart.increaseProductQuantity": "Increase quantity of {product}",
  "mobileShopCart.favorite": "Favorite",
  "mobileShopCart.delete": "Delete",
  "mobileShopCart.emptyCart": "Your purchase list is empty",
  "mobileShopCart.noSearchResults": "No matching products. Try another keyword",
  "mobileShopCart.emptyCartHint":
    "Choose products to review and check out together",
  "mobileShopCart.clearSearch": "Clear search",
  "mobileShopCart.shopNow": "Browse products",
  "mobileShopCart.changeQuantity": "Change purchase quantity",
  "mobileShopCart.currentStock": "Available stock",
  "mobileShopCart.pieces": "{count} items",
  "mobileShopCart.purchaseQuantity": "Purchase quantity",
  "mobileShopCart.decreaseInputQuantity": "Decrease entered quantity",
  "mobileShopCart.increaseInputQuantity": "Increase entered quantity",
  "mobileShopCart.quantityLimit":
    "Quantity cannot exceed available stock of {count}",
  "mobileShopCart.currentOutOfStock": "This product is out of stock",
  "mobileShopCart.cancel": "Cancel",
  "mobileShopCart.confirm": "Confirm",
  "mobileShopCart.selectedDetails": "Selected product details",
  "mobileShopCart.selectedSummary": "{kinds} products, {count} items total",
  "mobileShopCart.totalQuantity": "Total quantity: {count} items",
  "mobileShopCart.selectAll": "Select all",
  "mobileShopCart.viewDetails": "View details",
  "mobileShopCart.moveToFavorites": "Move to favorites",
  "mobileShopCart.syncing": "Syncing...",
  "mobileShopCart.selectProductFirst": "Select a product first",
  "mobileShopCart.favoriteComingSoon": "Favorites are coming soon",
  "mobileShopCart.selectToDelete": "Select products to delete",
  "mobileShopCart.confirmDeleteSelected":
    "Delete the {count} selected products?",
  "mobileShopCart.confirmRemoveProduct":
    "Remove this product from the purchase list?",
  "mobileShopCart.deleteProduct": "Delete product",
  "mobileShopCart.deleteSuccess": "Deleted",
  "mobileShopCart.stockLimitReached": "Stock limit reached",
  "mobileShopCart.invalidQuantity": "Enter a valid purchase quantity",
  "mobileShopCart.maximumQuantity": "You can purchase up to {count} items",
  "mobileShopCart.loadFailed":
    "Could not load the purchase list. Try again later",
  "mobileShopCart.multipleCurrencies": "Multiple currencies",
  "mobileShopCart.multipleCurrenciesHint":
    "The selected products use multiple currencies and will be split into separate orders. Continue?",
  "mobileShopCart.continueOrder": "Continue",
  "mobileShopCart.syncFailed": "Could not sync the purchase list",
});

// 移动交易订单
export const mobileTransactions = Object.freeze({
  "transactionOrders.title": "Trade Orders",
  "transactionOrders.all": "All",
  "transactionOrders.buy": "Purchases",
  "transactionOrders.sell": "Sales",
  "transactionOrders.follow": "Inquiries",
  "transactionOrders.pendingNotice": "You have {count} pending {unit}",
  "transactionOrders.pending": "View pending",
  "transactionOrders.loginRequired": "Please log in first",
  "transactionOrders.negotiatorRequired":
    "You are not a negotiator. Apply to become one",
  "transactionOrders.underReview": "Under review",
  "transactionOrders.applyNegotiator": "Apply as negotiator",
  "transactionOrders.loading": "Loading...",
  "transactionOrders.noMore": "You've reached the end",
  "transactionOrders.backToTop": "Back to top",
  "transactionOrders.noOrders": "No order data yet",
  "transactionOrders.noFollowOrders": "No inquiry orders yet",
  "transactionOrders.followUnit": "inquiries",
  "transactionOrders.orderUnit": "orders",
  "transactionOrders.underReviewMessage":
    "Your negotiator application is under review",
});

// 订单详情
export const details = Object.freeze({
  "preOrderDetail.title": "Product Order Details",
  "preOrderDetail.goodsCode": "Product Code",
  "preOrderDetail.edit": "Edit",
  "preOrderDetail.imageLoading": "Loading image",
  "preOrderDetail.unitPrice": "Unit Price",
  "preOrderDetail.stock": "Stock",
  "preOrderDetail.viewGoods": "View Product Details",
  "preOrderDetail.viewDetails": "View Details",
  "preOrderDetail.subOrders": "Product Sub-orders",
  "preOrderDetail.orderNumber": "Order Number",
  "preOrderDetail.quantity": "Quantity",
  "preOrderDetail.noSubOrders": "No sub-orders yet",
  "preOrderDetail.sellerContacts": "Seller Contacts",
  "preOrderDetail.buyerContacts": "Buyer Contacts",
  "preOrderDetail.negotiator": "Negotiator",
  "preOrderDetail.business": "Business Contact",
  "preOrderDetail.noContacts": "No contacts yet",
  "preOrderDetail.changeRecords": "Product Change History",
  "preOrderDetail.changedAt": "Changed At",
  "preOrderDetail.goodsPrice": "Product Unit Price",
  "preOrderDetail.goodsQuantity": "Product Quantity",
  "preOrderDetail.validUntil": "Valid Until",
  "preOrderDetail.none": "None",
  "preOrderDetail.noRecords": "No changes yet",
  "preOrderDetail.invite": "Invite Colleagues",
  "preOrderDetail.contactMethod": "Contact Method",
  "preOrderDetail.fillContact": "Enter contact details",
  "preOrderDetail.copyLink": "Copy Link",
  "preOrderDetail.noData": "No data yet",
  "preOrderDetail.changeGoods": "Edit Product Information",
  "preOrderDetail.price": "Price",
  "preOrderDetail.fillPrice": "Enter a price",
  "preOrderDetail.fillQuantity": "Enter a quantity",
  "preOrderDetail.selectDate": "Select a valid-until date",
  "preOrderDetail.submitChange": "Submit Changes",
  "preOrderDetail.chooseDate": "Select Valid-until Date",
  "preOrderDetail.usd": "USD",
  "preOrderDetail.cny": "CNY",
  "preOrderDetail.yuan": "CNY",
  "preOrderDetail.copySuccess": "Copied",
  "preOrderDetail.linkCopied": "Link copied",
  "preOrderDetail.missingCode": "Product code unavailable",
  "preOrderDetail.requireChange":
    "Enter a price, quantity, or valid-until date",
  "preOrderDetail.changeSuccess": "Changes saved",
  "preOrderDetail.changeFailedShort": "Unable to save changes",
  "preOrderDetail.changeFailed": "Unable to save changes. Try again",
  "preOrderDetail.retryLater": "Unable to save changes. Try again later",
  "transactionDetail.title": "Order Details",
  "transactionDetail.orderGoods": "Order Products",
  "transactionDetail.singleOrder": "Single Order",
  "transactionDetail.mergedOrder": "Merged Order",
  "transactionDetail.orderUnit": "orders",
  "transactionDetail.orderUnitOne": "order",
  "transactionDetail.orderLabel": "Order",
  "transactionDetail.copyContractNumber": "Copy contract number",
  "transactionDetail.fastOrder": "Fast order",
  "transactionDetail.logisticsDetails": "Logistics Details",
  "transactionDetail.serviceUnavailable": "Not available",
  "transactionDetail.copyTrackingNumber": "Copy tracking number",
  "transactionDetail.receiverInfo": "Recipient Information",
  "transactionDetail.progress": "Progress",
  "transactionDetail.businessProcess": "Business Process",
  "transactionDetail.businessProcessLoading": "Loading business process",
  "transactionDetail.noBusinessProcess": "No business process data yet",
  "transactionDetail.purchaseProcess": "Purchasing Process",
  "transactionDetail.salesProcess": "Sales Process",
  "transactionDetail.parallelNode": "Parallel node: {name}",
  "transactionDetail.parallel": "Parallel",
  "transactionDetail.current": "Current",
  "transactionDetail.remarks": "Remarks",
  "transactionDetail.nodeApprovals": "Node approvals: {count}",
  "transactionDetail.nodeApprovalDetails": "Node Approval Details",
  "transactionDetail.parallelApprovalDetails": "Parallel Node Approval Details",
  "transactionDetail.collapseProcess": "Collapse Full Process",
  "transactionDetail.expandProcess": "View Full Process",
  "transactionDetail.contract": "Contract",
  "transactionDetail.contractInfo": "Contract Information",
  "transactionDetail.orderDetails": "Order Details",
  "transactionDetail.parties": "Parties",
  "transactionDetail.attachments": "Attachments",
  "transactionDetail.logistics": "Logistics",
  "transactionDetail.afterSalesPolicy": "After-sales Terms",
  "transactionDetail.noAfterSalesPolicy": "No after-sales terms",
  "transactionDetail.productIndex": "Product {index}",
  "transactionDetail.sellerInfo": "Seller Information",
  "transactionDetail.buyerInfo": "Buyer Information",
  "transactionDetail.contacts": "Contacts",
  "transactionDetail.attachmentIntro":
    "Invoices, order receipts, payments, contracts, and shipping files are archived here",
  "transactionDetail.fileCount": "{count} files",
  "transactionDetail.attachmentCenter": "Attachment Center",
  "transactionDetail.attachmentCenterDescription":
    "View invoices, order receipts, payment records, contracts, and shipping documents in one place",
  "transactionDetail.totalFileCount": "Total: {count} files",
  "transactionDetail.expand": "Expand",
  "transactionDetail.collapse": "Collapse",
  "transactionDetail.expandContract": "Expand contract",
  "transactionDetail.collapseContract": "Collapse contract",
  "transactionDetail.invoice": "Final Invoice",
  "transactionDetail.noPiFiles": "No PI files yet",
  "transactionDetail.noInvoiceFiles": "No final invoices yet",
  "transactionDetail.noVatFiles": "No VAT invoices yet",
  "transactionDetail.noContractFiles": "No trade contracts yet",
  "transactionDetail.noOrderReceiptFiles": "No order receipts yet",
  "transactionDetail.noPaymentProofFiles": "No payment proofs yet",
  "transactionDetail.noShippingProofFiles": "No shipping proofs yet",
  "transactionDetail.noFiles": "No files yet",
  "transactionDetail.attachment": "Attachment",
  "transactionDetail.preview": "Preview",
  "transactionDetail.rejected": "Rejected",
  "transactionDetail.reject": "Reject",
  "transactionDetail.unknownFile": "Unknown file",
  "transactionDetail.pdfFile": "PDF file",
  "transactionDetail.imageFile": "Image file",
  "transactionDetail.videoFile": "Video file",
  "transactionDetail.attachmentFile": "Attachment file",
  "transactionDetail.rejectInvoice": "Reject Invoice",
  "transactionDetail.rejectPaymentProof": "Reject Payment Proof",
  "transactionDetail.noAttachment": "No {label} yet",
  "transactionDetail.shippingCompany": "Shipping Company",
  "transactionDetail.trackingNumber": "Tracking Number",
  "transactionDetail.logisticsProgress": "Shipping Progress",
  "transactionDetail.receiptAddress": "Delivery Address",
  "transactionDetail.contactPerson": "Contact",
  "transactionDetail.contactPhone": "Phone Number",
  "transactionDetail.expandLogistics": "View Shipping Details",
  "transactionDetail.collapseLogistics": "Hide Shipping Details",
  "transactionDetail.viewRemarks": "View Remarks",
  "transactionDetail.closeRemarks": "Close remarks dialog",
  "transactionDetail.close": "Close",
  "transactionDetail.reviewRejectReason": "Enter Review Rejection Reason",
  "transactionDetail.rejectReason": "Enter Rejection Reason",
  "transactionDetail.closeReject": "Close rejection dialog",
  "transactionDetail.confirmSubmit": "Confirm and Submit",
  "transactionDetail.tradeOrders": "Trade Orders",
  "transactionDetail.viewDetails": "View Details",
  "transactionDetail.contractNumber": "Contract Number",
  "transactionDetail.deliveryDate": "Delivery Date",
  "transactionDetail.orderType": "Order Type",
  "transactionDetail.trade": "Trade",
  "transactionDetail.supplyChain": "Supply Chain",
  "transactionDetail.factoring": "Factoring",
  "transactionDetail.totalPrice": "Total Price",
  "transactionDetail.commission": "Total Commission",
  "transactionDetail.quantity": "Quantity",
  "transactionDetail.orderIndex": "Order {index}",
  "transactionDetail.orderInfo": "Order Information",
  "transactionDetail.orderNumber": "Order Number",
  "transactionDetail.productName": "Product Name",
  "transactionDetail.productBrand": "Brand",
  "transactionDetail.partNumber": "Part Number",
  "transactionDetail.deliveryRegion": "Delivery Region",
  "transactionDetail.unitPrice": "Unit Price",
  "transactionDetail.productQuantity": "Product Quantity",
  "transactionDetail.productTotal": "Product Total",
  "transactionDetail.sellerCompany": "Seller Information",
  "transactionDetail.buyerCompany": "Buyer Information",
  "transactionDetail.companyName": "Company Name",
  "transactionDetail.companyEnglishName": "Company Name (English)",
  "transactionDetail.taxNumber": "Tax ID",
  "transactionDetail.registrationNumber": "Business Registration Number",
  "transactionDetail.primaryContact": "Primary Contact",
  "transactionDetail.companyAddress": "Company Address",
  "transactionDetail.bank": "Bank",
  "transactionDetail.bankEnglishName": "Bank Name (English)",
  "transactionDetail.bankAccount": "Bank Account",
  "transactionDetail.receivingAccount": "Receiving Account",
  "transactionDetail.recipient": "Recipient",
  "transactionDetail.recipientPhone": "Recipient Phone",
  "transactionDetail.placeOrderInfo": "Order Information",
  "transactionDetail.originalPrice": "Original Price",
  "transactionDetail.offerPrice": "Offer Price",
  "transactionDetail.approx": "Approx.",
  "transactionDetail.originCertificate": "Certificate of Origin",
  "transactionDetail.inviteSellerLink": "Invite Seller Link",
  "transactionDetail.agentService": "Order Customer Service",
  "transactionDetail.purchaseBusiness": "Purchasing Specialist",
  "transactionDetail.salesBusiness": "Sales Specialist",
  "transactionDetail.purchaseContacts": "Purchasing Contacts",
  "transactionDetail.salesContacts": "Sales Contacts",
  "transactionDetail.platformContacts": "Platform Contacts",
  "transactionDetail.proformaInvoice": "Proforma Invoice",
  "transactionDetail.orderReceipt": "Order Receipt",
  "transactionDetail.vatInvoice": "VAT Invoice",
  "transactionDetail.paymentProof": "Payment Proof",
  "transactionDetail.shippingProof": "Shipping Proof",
  "transactionDetail.tradeContract": "Trade Contract",
  "transactionDetail.pickedUp": "Picked Up",
  "transactionDetail.pickedUpDesc":
    "The parcel was received by the pickup point",
  "transactionDetail.inTransit": "In Transit",
  "transactionDetail.inTransitDesc": "The parcel is in transit",
  "transactionDetail.outForDelivery": "Out for Delivery",
  "transactionDetail.outForDeliveryDesc":
    "The parcel is out for delivery. Please keep your phone available",
  "transactionDetail.delivered": "Delivered",
  "transactionDetail.deliveredDesc": "The parcel was signed for",
  "transactionDetail.reviewConfirm": "Confirm Review",
  "transactionDetail.reviewQuestion": "Approve this {target}?",
  "transactionDetail.approve": "Approve",
  "transactionDetail.cancel": "Cancel",
  "transactionDetail.rejectSuccess": "Rejected",
  "transactionDetail.rejectFailed": "Unable to reject. Try again",
  "transactionDetail.noContractId":
    "Contract ID unavailable; review cannot be submitted",
  "transactionDetail.reviewFailed": "Unable to complete review. Try again",
  "transactionDetail.reviewApproved": "Review approved",
  "transactionDetail.reviewRejected": "Review rejected",
  "transactionDetail.copySuccess": "Copied",
  "transactionDetail.copyFailed": "Unable to copy",
  "transactionDetail.previewFailed": "Unable to preview attachment",
  "transactionDetail.authFailed": "Authorization failed",
  "transactionDetail.loadFailed": "Unable to load order details",
  "transactionDetail.afterSaleApplication": "After-sales Request",
  "transactionDetail.transactionNumber": "Transaction Number",
  "transactionDetail.afterSaleType": "Request Type",
  "transactionDetail.selectType": "Select a type",
  "transactionDetail.afterSaleReason": "Reason",
  "transactionDetail.selectReason": "Select a reason",
  "transactionDetail.description": "Detailed Description",
  "transactionDetail.fillDescription": "Enter details",
  "transactionDetail.imageProof": "Image Evidence",
  "transactionDetail.imageHelp":
    "JPG, JPEG, or PNG. Up to 9 images; product and packaging photos are recommended",
  "transactionDetail.videoProof": "Video Evidence",
  "transactionDetail.uploadVideo": "Upload Video Evidence",
  "transactionDetail.videoHelp":
    "MP4 or AVI. Up to 3 videos; product demos or issue recordings are recommended",
  "transactionDetail.submitApplication": "Submit Request",
  "transactionDetail.reset": "Reset",
  "transactionDetail.refundOnly": "Refund Only",
  "transactionDetail.returnAndRefund": "Return and Refund",
  "transactionDetail.exchange": "Exchange",
  "transactionDetail.factoryRepair": "Factory Repair",
  "transactionDetail.partMismatch":
    "Part number does not match the description",
  "transactionDetail.qualityIssue": "Product quality issue",
  "transactionDetail.shortQuantity": "Insufficient quantity",
  "transactionDetail.differentPart": "Need a different part number",
  "transactionDetail.suspectedFake": "Suspected counterfeit",
  "transactionDetail.other": "Other",
  "transactionDetail.missingAuthCode":
    "Authorization details are missing. Please try again",
  "transactionDetail.loginSuccess": "Signed in",
  "transactionDetail.requestError": "Request failed",
  "transactionDetail.missingOrderId": "Order ID unavailable",
  "transactionDetail.selectTransaction": "Select a transaction number",
  "transactionDetail.selectAfterSaleType": "Select an after-sales request type",
  "transactionDetail.selectAfterSaleReason": "Select a reason",
  "transactionDetail.uploadImageProof": "Upload image evidence",
  "transactionDetail.submitFailed": "Unable to submit. Try again",
  "transactionDetail.sellerRole": "Seller",
  "transactionDetail.businessRole": "Business Contact",
  "transactionDetail.negotiatorRole": "Negotiator",
  "transactionDetail.buyerRole": "Buyer",
});

// 桌面购物车
export const desktopCart = Object.freeze({
  "pcCart.cartTitle": "Purchase list",
  "pcCart.productCount": "{count} products",
  "pcCart.searchPlaceholder": "Search by part number or product name",
  "pcCart.selectAll": "Select all",
  "pcCart.deleteSelected": "Delete selected",
  "pcCart.moveToFavorites": "Move to favorites",
  "pcCart.selectedProducts": "{count} products selected",
  "pcCart.partNumber": "Part number",
  "pcCart.stock": "Stock",
  "pcCart.pieces": "{count} pcs",
  "pcCart.approx": "Approx.",
  "pcCart.subtotal": "Subtotal",
  "pcCart.deleteProduct": "Delete product",
  "pcCart.emptyTitle": "Your purchase list is empty",
  "pcCart.emptyDescription": "You haven't added any products yet",
  "pcCart.shopNow": "Browse products",
  "pcCart.orderSummary": "Order summary",
  "pcCart.selectedItems": "Selected products",
  "pcCart.totalItems": "Total quantity",
  "pcCart.usdItemsTotal": "USD products total",
  "pcCart.cnyItemsTotal": "CNY products total",
  "pcCart.total": "Total",
  "pcCart.overallTotal": "Combined total",
  "pcCart.submitIntent": "Submit purchase inquiry",
  "pcCart.pendingConfirmation": "{count} products pending confirmation",
  "pcCart.priceFluctuation": "Product prices may change with the market",
  "pcCart.paymentMethods": "Multiple payment methods supported",
  "pcCart.selectedPreview": "Selected product preview",
  "pcCart.selectFavoriteFirst": "Select products to favorite first",
  "pcCart.favoriteSuccess": "Added to favorites",
  "pcCart.selectDeleteFirst": "Select products to delete first",
  "pcCart.confirmDeleteSelected": "Delete the selected products?",
  "pcCart.confirmDeleteProduct": "Delete this product?",
  "pcCart.notice": "Notice",
  "pcCart.confirm": "Confirm",
  "pcCart.cancel": "Cancel",
  "pcCart.deleteSuccess": "Deleted successfully",
  "pcCart.selectProductFirst": "Select a product first",
  "pcCart.multiCurrencyWarning":
    "Products in multiple currencies will be split into separate orders. Continue?",
  "pcCart.backToCart": "Back to purchase list",
  "pcCart.orderProducts": "Products to order",
  "pcCart.productImage": "Product image",
  "pcCart.unnamedProduct": "Unnamed product",
  "pcCart.model": "Model: ",
  "pcCart.quantity": "Quantity: ",
  "pcCart.unitPiece": "pcs",
  "pcCart.noSelectedProducts": "No selected products",
  "pcCart.productsTotal": "Products total",
  "pcCart.exchangeDisclaimer":
    "Converted at the current exchange rate for reference only",
  "pcCart.buyerInfo": "Buyer information",
  "pcCart.buyerInfoHint": "Used to prepare the purchase inquiry",
  "pcCart.companyName": "Company name",
  "pcCart.companyPlaceholder": "Enter company name",
  "pcCart.taxNumber": "Tax ID",
  "pcCart.taxPlaceholder": "Enter tax ID",
  "pcCart.contact": "Contact",
  "pcCart.contactPlaceholder": "Enter contact name",
  "pcCart.contactDetails": "Contact details",
  "pcCart.contactDetailsPlaceholder": "Enter contact details",
  "pcCart.deliveryAddress": "Delivery address",
  "pcCart.deliveryAddressPlaceholder": "Enter delivery address",
  "pcCart.uploadOrderInfo": "Upload order documents",
  "pcCart.uploadHint":
    "Upload a contract, purchase order or other order documents; up to 10 files",
  "pcCart.uploadFile": "Upload files",
  "pcCart.productDetails": "{name} details",
  "pcCart.productNumber": "Product {count}",
  "pcCart.contactPhone": "Contact phone",
  "pcCart.submitting": "Submitting",
  "pcCart.submitPurchaseIntent": "Submit purchase inquiry",
  "pcCart.loginFirst": "Please log in first",
  "pcCart.submitSuccess": "Purchase inquiry submitted successfully!",
});

// 合同审核
export const contractReview = Object.freeze({
  "contractReview.back": "Back",
  "contractReview.salesOrderInfo": "Sales Order Information",
  "contractReview.salesOrderDescription":
    "Review products, order details, and the sales contract",
  "contractReview.purchaseOrderInfo": "Purchase Order Information",
  "contractReview.purchaseOrderDescription":
    "Review products, contract, and purchase details",
  "contractReview.productInfo": "Product Information",
  "contractReview.contractInfo": "Contract Information",
  "contractReview.inviteSeller": "Invite seller to link product",
  "contractReview.productProvider": "Product Provider",
  "contractReview.noTerms": "None",
  "contractReview.productIndex": "Product {index}",
  "contractReview.contractNumberPlaceholder": "Enter contract number",
  "contractReview.copySuccess": "Copied",
  "contractReview.copyFailed": "Could not copy",
  "contractReview.sellerInfo": "Seller Information",
  "contractReview.buyerInfo": "Buyer Information",
  "contractReview.sellerPaymentInfo": "Seller Payment Details",
  "contractReview.moreSellerInfo": "More Seller Details",
  "contractReview.moreBuyerInfo": "More Buyer Details",
  "contractReview.moreBuyerPaymentInfo": "More Buyer Payment Details",
  "contractReview.newContact": "Add Contact",
  "contractReview.changeContact": "Change Contact",
  "contractReview.addBank": "Add Bank",
  "contractReview.changeBank": "Change Bank",
  "contractReview.clear": "Clear",
  "contractReview.fillRemarks": "Enter remarks",
  "contractReview.attachment": "Attachment",
  "contractReview.uploadAttachment": "Upload attachment",
  "contractReview.requiredField": "{party}: {field} is required",
  "contractReview.seller": "Seller",
  "contractReview.buyer": "Buyer",
  "contractReview.contactAdded": "Contact added",
  "contractReview.contactChanged": "Contact changed",
  "contractReview.productName": "Product Name",
  "contractReview.partNumber": "Part Number",
  "contractReview.productQuantity": "Product Quantity",
  "contractReview.unitPrice": "Unit Price",
  "contractReview.productTotal": "Product Total",
  "contractReview.brand": "Brand",
  "contractReview.productNumber": "Product Number",
  "contractReview.orderNumber": "Order Number",
  "contractReview.deliveryRegion": "Delivery Region",
  "contractReview.dateCode": "Date Code (DC)",
  "contractReview.goodsCondition": "Goods Condition",
  "contractReview.deliveryDate": "Delivery Date",
  "contractReview.orderType": "Order Type",
  "contractReview.afterSalesTerms": "After-sales Terms",
  "contractReview.orderRemarks": "Order Remarks",
  "contractReview.contractNumber": "Contract Number",
  "contractReview.grandTotal": "Grand Total",
  "contractReview.paymentMethod": "Payment Method",
  "contractReview.companyName": "Company Name",
  "contractReview.companyNameZh": "Company Name (Chinese)",
  "contractReview.companyNameEn": "Company Name (English)",
  "contractReview.accountName": "Account Name",
  "contractReview.contact": "Contact",
  "contractReview.primaryContact": "Primary Contact",
  "contractReview.contactPhone": "Contact Phone",
  "contractReview.phone": "Phone",
  "contractReview.remarks": "Remarks",
  "contractReview.companyAddress": "Company Address",
  "contractReview.taxNumber": "Tax Number",
  "contractReview.registrationNumber": "Business Registration Number",
  "contractReview.bankNameEn": "Bank Name (English)",
  "contractReview.bankNameZh": "Bank Name (Chinese)",
  "contractReview.bank": "Bank",
  "contractReview.bankAccount": "Bank Account",
  "contractReview.bankAddressZh": "Bank Address (Chinese)",
  "contractReview.bankAddressEn": "Bank Address (English)",
  "contractReview.bankBranch": "Bank Branch",
  "contractReview.bankBranchCode": "Bank Branch Code",
  "contractReview.receivingAccount": "Receiving Account",
  "contractReview.shippingAddress": "Shipping Address",
  "contractReview.recipient": "Recipient",
  "contractReview.recipientPhone": "Recipient Phone",
  "contractReview.salesTotal": "Sales Total",
  "contractReview.purchaseTotal": "Purchase Total",
  "contractReview.profit": "Profit",
  "contractReview.orderImages": "Order Images",
  "contractReview.noAttachments": "No attachments yet",
  "contractReview.tradeContract": "Trade Contract",
  "contractReview.customerUploadsSingle":
    "Customer uploads the single-stamped contract",
  "contractReview.uploadTradeContract": "Upload Trade Contract",
  "contractReview.viewTradeContract": "View Trade Contract",
  "contractReview.confirmUpload": "Confirm Upload",
  "contractReview.uploadTemplate": "Upload Contract Template",
  "contractReview.contractTemplate": "Contract Template",
  "contractReview.uploadSingle": "Upload Single-stamped Contract",
  "contractReview.singleContract": "Single-stamped Contract",
  "contractReview.uploadDual": "Upload Dual-stamped Contract",
  "contractReview.dualContract": "Dual-stamped Contract",
  "contractReview.approvalAttachmentsHint":
    "Upload invoices and other files needed for approval",
  "contractReview.otherAttachments": "Other Attachments",
  "contractReview.contractRemarks": "Contract Remarks",
  "contractReview.fillContractRemarks": "Enter contract remarks",
  "contractReview.noRemarks": "No remarks yet",
  "contractReview.buyerAttachments": "Buyer Attachments",
  "contractReview.myAttachments": "My Attachments",
  "contractReview.purchaseSellerInfo": "Purchase-side Seller Information",
  "contractReview.purchaseBuyerInfo": "Purchase-side Buyer Information",
  "contractReview.reject": "Reject",
  "contractReview.relatedOrderHint":
    "Select previous orders, contracts, or payment reviews to link to this sales order",
  "contractReview.rejectReason": "Enter rejection reason",
  "contractReview.confirmSubmit": "Confirm Submission",
  "contractReview.addCc": "Add CC Recipients",
  "contractReview.addCcHint": "Search for people to update on this sales order",
  "contractReview.searchCc": "Search CC recipients",
  "contractReview.cc": "CC Recipient",
  "contractReview.contractPreview": "Contract Preview",
  "contractReview.initiateApproval": "Start Contract Approval",
  "contractReview.reviewSalesContract": "Review Sales Contract",
  "contractReview.viewSalesContract": "View Sales Contract",
  "contractReview.reviewSalesOrder": "Review Sales Order",
  "contractReview.viewSalesOrder": "View Sales Order",
  "contractReview.confirmTradeContract": "Confirm Trade Contract",
  "contractReview.approveReview": "Approve",
  "contractReview.confirmTemplate": "Confirm Contract Template",
  "contractReview.confirmSalesOrder": "Confirm Sales Order",
  "contractReview.trade": "Trade",
  "contractReview.supplyChain": "Supply Chain",
  "contractReview.factoring": "Factoring",
  "contractReview.payBeforeDelivery": "Pay Before Delivery",
  "contractReview.payAfterDelivery": "Pay After Delivery",
  "contractReview.notStarted": "Not Started",
  "contractReview.underReview": "Under Review",
  "contractReview.approved": "Approved",
  "contractReview.rejected": "Rejected",
  "contractReview.unknown": "Unknown",
  "contractReview.reviewRemarks": "Review Remarks",
  "contractReview.fillReviewerRemarks": "Enter reviewer remarks",
});

// 跟单
export const follow = Object.freeze({
  "pcFollow.searchPlaceholder":
    "Search product name, part number, brand, type or quantity",
  "pcFollow.loginRequired": "Please log in first",
  "pcFollow.notNegotiator": "You are not a negotiator. Apply to become one.",
  "pcFollow.underReview": "Under review",
  "pcFollow.applyNegotiator": "Apply to become a negotiator",
  "pcFollow.businessTracking": "Business order tracking",
  "pcFollow.negotiatorTracking": "Negotiator order tracking",
  "pcFollow.buyer": "Buyer",
  "pcFollow.seller": "Seller",
  "pcFollow.reviewInProgress": "Your application is under review",
  "pcFollow.titleWithRole": "{role} {title}",
});

// 桌面订单组件
export const desktopComponents = Object.freeze({
  "pcOrder.merged": "Merged",
  "pcOrder.contractNumber": "Contract no.: ",
  "pcOrder.orderNumber": "Order no.: ",
  "pcOrder.productNumber": "Product no.: ",
  "pcOrder.split": "Split",
  "pcOrder.revoke": "Revoke",
  "pcOrder.inviteSellerLink": "Invite seller link",
  "pcOrder.splitOrder": "Split order",
  "pcOrder.fastOrder": "Fast order",
  "pcOrder.personLabelSeparator": ": ",
  "pcOrder.buyerRole": "Buyer",
  "pcOrder.sellerRole": "Seller",
  "pcOrder.salesNegotiatorRole": "Sales Negotiator",
  "pcOrder.salesBusinessRole": "Sales Business Contact",
  "pcOrder.purchaseNegotiatorRole": "Purchasing Negotiator",
  "pcOrder.purchaseBusinessRole": "Purchasing Business Contact",
  "pcOrder.supervisorRole": "Supervisor",
  "pcOrder.inspectorRole": "Inspector",
  "pcOrder.uploadTradeContract": "Upload trade contract",
  "pcOrder.uploadSingleStampContract": "Upload single-stamped contract",
  "pcOrder.uploadDualStampContract": "Upload dual-stamped contract",
  "pcOrder.editTradeContract": "Edit trade contract",
  "pcOrder.initiateContractReview": "Start contract approval",
  "pcOrder.initiateTemplateReview": "Start contract template approval",
  "pcOrder.viewTradeContract": "View trade contract",
  "pcOrder.viewPaymentProof": "View payment proof",
  "pcOrder.viewContractTemplate": "View contract template",
  "pcOrder.confirmTradeContract": "Confirm trade contract",
  "pcOrder.confirmContractTemplate": "Confirm contract template",
  "pcOrder.productPublished": "Product published",
  "pcOrder.platformListed": "Listed on platform",
  "pcOrder.brand": "Brand",
  "pcOrder.name": "Name",
  "pcOrder.quantity": "Quantity",
  "pcOrder.originalQuantity": "Quantity before split",
  "pcOrder.unitPrice": "Unit price",
  "pcOrder.viewDetails": "View details",
  "pcOrder.withdrawOrder": "Withdraw order",
  "pcOrder.generateSalesOrder": "Create sales order",
  "pcOrder.generatePurchaseOrder": "Create purchase order",
  "pcOrder.inspect": "Inspect goods",
  "pcOrder.inspectionDetails": "Inspection details",
  "pcOrder.reviewNow": "Leave a review",
  "pcOrder.viewReview": "View review",
  "pcOrder.uploadInvoice": "Upload invoice",
  "pcOrder.confirmPayment": "Confirm payment received",
  "pcOrder.uploadShipping": "Upload shipping details",
  "pcOrder.uploadPaymentProof": "Upload payment proof",
  "pcOrder.confirmReceipt": "Confirm receipt",
  "pcOrder.purchaseProduct": "Purchase product",
  "pcOrder.salesProduct": "Sales product",
  "pcOrder.onlyBuyerMayWithdraw": "Only the buyer can withdraw this order",
  "pcOrder.orderIdUnavailable": "Order ID unavailable",
  "pcOrder.withdrawWarning":
    "You will need to place a new order after withdrawal. Withdraw this order?",
  "pcOrder.notice": "Notice",
  "pcOrder.confirmWithdraw": "Confirm withdrawal",
  "pcOrder.cancel": "Cancel",
  "pcOrder.withdrawSuccess": "Withdrawn successfully",
  "pcOrder.revokeSplitWarning": "Revoke the split order?",
  "pcOrder.copySuccess": "Copied",
  "pcOrder.copyFailed": "Could not copy",
  "pcOrder.paymentProofRequired": "Upload payment proof first",
  "pcOrder.paymentProofUploaded": "Payment proof uploaded",
  "pcOrder.proofOrNoteRequired": "Upload proof or add a note",
  "pcOrder.shippingUploaded": "Shipping details uploaded",
  "pcOrder.receiptConfirmed": "Receipt confirmed",
  "pcOrder.paymentConfirmed": "Payment receipt confirmed",
  "pcOrder.invoiceRequired": "Upload at least one invoice",
  "pcOrder.invoiceUploaded": "Invoice uploaded",
  "pcOrder.splitDialogTitle": "Split order",
  "pcOrder.splitDialogHint":
    "Choose the number of orders and allocate the quantity",
  "pcOrder.totalProducts": "Total quantity",
  "pcOrder.productUnitPrice": "Product unit price",
  "pcOrder.splitInto": "Split into",
  "pcOrder.splitEvenlyHint":
    "Quantities are allocated evenly by default; you can adjust them",
  "pcOrder.orderUnit": "orders",
  "pcOrder.quantityPerOrder": "Quantity per order",
  "pcOrder.fullyAllocated": "Fully allocated",
  "pcOrder.remaining": "{count} remaining",
  "pcOrder.orderNumbered": "Order {count}",
  "pcOrder.confirmSplit": "Confirm split",
  "pcOrder.invalidSplitQuantity":
    "Use at least two orders, and allocate the full product quantity",
  "pcOrder.splitSuccess": "Order split successfully",
  "pcOrder.splitFailed": "Could not split order",
});

// 桌面交易订单
export const desktopTransactions = Object.freeze({
  "pcTransaction.title": "Transaction orders",
  "pcTransaction.pendingAction": "to handle",
  "pcTransaction.allOrders": "All orders",
  "pcTransaction.purchaseOrders": "Purchase orders",
  "pcTransaction.salesOrders": "Sales orders",
  "pcTransaction.intentions": "Purchase inquiries",
  "pcTransaction.searchAll": "Search all",
  "pcTransaction.searchName": "Search by name",
  "pcTransaction.searchPartNumber": "Search by part number",
  "pcTransaction.searchPlaceholder": "Search {field}",
  "pcTransaction.name": "name",
  "pcTransaction.partNumberShort": "part number",
  "pcTransaction.nameAndPartNumber": "name or part number",
  "pcTransaction.inviteCollaboration": "Invite collaborators",
  "pcTransaction.orderingCompany": "Ordering company",
  "pcTransaction.supplier": "Supplier",
  "pcTransaction.productName": "Product name",
  "pcTransaction.partNumber": "Model / part number",
  "pcTransaction.startDate": "Order start date",
  "pcTransaction.to": "to",
  "pcTransaction.endDate": "Order end date",
  "pcTransaction.search": "Search",
  "pcTransaction.exportReport": "Export report",
  "pcTransaction.loading": "Loading...",
  "pcTransaction.noMore": "No more results",
  "pcTransaction.backToTop": "Back to top",
  "pcTransaction.pendingFollows": "You have {count} follow-ups ",
  "pcTransaction.pendingOrders": "You have {count} orders ",
  "pcTransaction.noIntentionOrders": "No purchase inquiries yet",
  "pcTransaction.noOrders": "No orders yet",
  "pcTransaction.exportFailed": "Could not export report",
  "pcTransaction.salesPaymentReport": "Sales payment report",
  "pcTransaction.purchasePaymentReport": "Purchase payment report",
  "pcTransaction.summaryReport": "Transaction summary report",
  "pcTransaction.allDates": "all",
  "pcTransaction.exportSuccess": "Report exported successfully",
});

// 个人订单
export const personal = Object.freeze({
  "personalOrderList.buyerTitle": "I Am a Buyer",
  "personalOrderList.saleTitle": "My Sales Orders",
  "personalOrderList.followTitle": "My Follow-up Orders",
  "personalOrderList.noMore": "You've reached the end",
  "personalOrderList.noData": "No data yet",
  "personalOrderList.imageLoading": "Loading image",
  "personalOrderList.supplyInfo": "Supply Information",
  "personalOrderList.unitPrice": "Unit Price",
  "personalOrderList.quantity": "Quantity",
  "personalOrderList.viewDetails": "View Details",
  "personalOrderList.completeInfo": "Complete Information",
  "personalOrderList.image": "Image",
  "personalOrderList.title": "Title",
  "personalOrderList.brand": "Brand",
  "personalOrderList.time": "Time",
  "personalOrderList.action": "Action",
  "personalOrderList.all": "All",
  "personalOrderList.pendingConfirmation": "Pending Confirmation",
  "personalOrderList.pendingCommission": "Commission Due",
  "personalOrderList.transactionComplete": "Transaction Complete",
  "personalOrderList.pendingReview": "Pending Review",
  "personalOrderList.reviewed": "Reviewed",
  "personalOrderList.supply": "Supply",
  "personalOrderList.buyRequest": "Buy Request",
  "contractList.title": "My Contracts",
  "contractList.auditStatus": "Review Status",
  "contractList.selectStatus": "Select status",
  "contractList.contractNumber": "Contract Number",
  "contractList.pending": "Pending Review",
  "contractList.approved": "Approved",
  "contractList.rejected": "Rejected",
  "contractList.all": "All",
  "contractList.remark": "Remarks",
  "contractList.createdAt": "Created At",
  "contractList.action": "Action",
  "contractList.viewDetails": "View Details",
  "orderDetail.title": "Order Details",
  "orderDetail.status": "Order Status",
  "orderDetail.commissionInfo": "Commission",
  "orderDetail.commissionAmount": "Commission Amount",
  "orderDetail.paymentStatus": "Payment Status",
  "orderDetail.unpaid": "Unpaid",
  "orderDetail.paid": "Paid",
  "orderDetail.paymentTime": "Payment Time",
  "orderDetail.orderInfo": "Order Information",
  "orderDetail.orderNumber": "Order Number",
  "orderDetail.orderTime": "Order Time",
  "orderDetail.goodsAmount": "Total Goods Amount",
  "orderDetail.orderAmount": "Order Amount",
  "orderDetail.buyer": "Buyer",
  "orderDetail.buyerCompany": "Buyer Intermediary Company",
  "orderDetail.seller": "Seller",
  "orderDetail.sellerCompany": "Seller Intermediary Company",
  "orderDetail.payCommission": "Pay Commission",
  "orderDetail.uploadPaymentProof": "Upload Payment Proof",
  "orderDetail.confirmReceipt": "Confirm Receipt",
  "orderDetail.commissionPayment": "Commission Payment",
  "orderDetail.payNow": "Pay ￥{amount} Now",
  "orderDetail.paymentProof": "Payment Proof",
  "orderDetail.paymentEvidence": "Payment Evidence",
  "orderDetail.submit": "Submit",
  "orderDetail.confirmPayment": "Confirm Payment Received",
  "orderDetail.shippingCompany": "Shipping Company",
  "orderDetail.trackingNumber": "Tracking Number",
  "orderDetail.shippingProof": "Shipping Proof",
  "orderDetail.uploadShippingProof": "Upload Shipping Proof",
  "orderDetail.shippingInfo": "Upload Shipping Information",
  "orderDetail.ship": "Ship",
  "orderDetail.goShip": "Ship Order",
  "orderDetail.invoiceInfo": "Upload Invoice Information",
  "orderDetail.invoiceProof": "Invoice Proof",
  "orderDetail.uploadInvoiceProof": "Upload Invoice Proof",
  "orderDetail.required": "Required",
  "orderDetail.validNumber": "Enter a valid number",
  "orderDetail.paymentSuccess": "Payment successful!",
  "orderDetail.uploadSuccess": "Upload successful!",
  "orderDetail.receiptSuccess": "Receipt confirmed!",
  "orderDetail.confirmSuccess": "Confirmed!",
  "orderDetail.shipSuccess": "Shipment confirmed!",
  "orderDetail.wechatQrAlt": "WeChat payment QR code",
  "orderDetail.loading": "Loading...",
});

// 拆单
export const split = Object.freeze({
  "splitOrder.title": "Split order",
  "splitOrder.close": "Close split-order dialog",
  "splitOrder.yuan": "CNY",
  "splitOrder.totalQuantity": "Total quantity: ",
  "splitOrder.splitInto": "Split the order into",
  "splitOrder.orderCount": "Number of resulting orders",
  "splitOrder.ordersUnit": "orders",
  "splitOrder.orderLabel": "Order {label}:",
  "splitOrder.splitQuantity": "Quantity",
  "splitOrder.remaining": "Remaining to allocate: {count}",
  "splitOrder.confirm": "Confirm split",
  "splitOrder.unallocatedQuantity": "Some quantity has not been allocated yet",
  "splitOrder.success": "Order split successfully",
  "splitOrder.failed": "Could not split the order",
});

// 出库单列表：状态、仓库及接口错误仅作显示翻译，不改业务值。
export const outboundList = Object.freeze({
  "outboundList.title": "Dispatch orders",
  "outboundList.status": "Dispatch order status",
  "outboundList.allStatuses": "All statuses",
  "outboundList.allWarehouses": "All warehouses",
  "outboundList.startDate": "Start date",
  "outboundList.endDate": "End date",
  "outboundList.rangeSeparator": "to",
  "outboundList.dispatchStartDate": "Dispatch start date",
  "outboundList.dispatchEndDate": "Dispatch end date",
  "outboundList.add": "Add dispatch order",
  "outboundList.total": "{count} records",
  "outboundList.empty": "No dispatch orders",
  "outboundList.pending": "Pending review",
  "outboundList.inReview": "Under review",
  "outboundList.approved": "Approved",
  "outboundList.rejected": "Rejected",
  "outboundList.warehouseHengda": "Hong Kong Hengda",
  "outboundList.warehouseHualian": "Hong Kong Hualian",
  "outboundList.warehouseShenzhen": "Shenzhen",
  "outboundList.review": "Review dispatch order",
  "outboundList.view": "View dispatch order",
  "outboundList.details": "View details",
  "outboundList.rejectionReason": "Rejection reason",
  "outboundList.invalidId": "Invalid dispatch order ID. Refresh the list",
  "outboundList.loadFailed": "Could not load dispatch orders. Try again",
  "outboundList.dateOrderError":
    "The dispatch start date must not be later than the end date",
  "outboundList.queryRequired": "Query parameters are required",
  "outboundList.invalidStatus": "Approval status must be between 0 and 3",
  "outboundList.invalidPage": "Page number must be greater than 0",
  "outboundList.invalidPageSize": "Page size must be between 1 and 100",
  "outboundList.forbidden": "You are not allowed to operate dispatch orders",
  "outboundList.unavailable": "Dispatch operation failed. Try again later",
});

// 采购／销售订单生成与关联内容：三语仅作用于显示，不改选项、审批状态及原始正文。
export const contractFlow = Object.freeze({
  "contractFlow.bankAttachments": "Bank attachments",
  "contractFlow.purchaseTitle": "Purchasing operations: create purchase order",
  "contractFlow.salesTitle": "Sales operations: create sales order",
  "contractFlow.purchaseIntro":
    "Enter purchase order details and confirm the trading parties and review workflow",
  "contractFlow.salesIntro":
    "Enter sales order details and confirm the trading parties and review workflow",
  "contractFlow.purchaseOnBehalf": "Procurement and payment on behalf",
  "contractFlow.purchaseWithAdvance": "Procurement with advance payment",
  "contractFlow.factoryPackaging": "Original manufacturer packaging",
  "contractFlow.nonFactoryPackaging": "Non-original manufacturer packaging",
  "contractFlow.selfPackagedChips": "Self-packaged chips",
  "contractFlow.testedOriginalMarking": "Original marking (tested)",
  "contractFlow.nonOriginalMarking": "Non-original marking",
  "contractFlow.refurbished": "Refurbished",
  "contractFlow.used": "Used",
  "contractFlow.salesContract": "Sales contract",
  "contractFlow.purchaseContract": "Purchase contract",
  "contractFlow.paymentReview": "Payment review",
  "contractFlow.order": "Order",
  "contractFlow.payment": "Payment",
  "contractFlow.relatedSearchPlaceholder":
    "Search related order numbers, titles or content",
  "contractFlow.relatedNotFound": "No matching related content",
  "contractFlow.relatedUnavailable": "No content available to link",
  "contractFlow.selectedCount": "{count} selected",
  "contractFlow.noDetails": "No details available",
  "contractFlow.missingDetails": "No details available for {type}",
  "contractFlow.relatedLoadFailed": "Could not load related content",
  "contractFlow.expandRelated": "Expand related content",
  "contractFlow.collapseRelated": "Collapse related content",
  "contractFlow.deleteRelated": "Remove related content",
  "contractFlow.selectRelatedOrder": "Select related order",
  "contractFlow.deselectRelatedOrder": "Deselect related order",
  "contractFlow.purchaseRelatedHint":
    "Select historical orders, contracts or payment reviews to link to this purchase order",
  "contractFlow.salesRelatedHint":
    "Select historical orders, contracts or payment reviews to link to this sales order",
  "contractFlow.paymentRelatedHint":
    "Select historical orders, contracts or payment reviews to link to this payment approval",
  "contractFlow.purchaseCcHint":
    "Search and select people to receive updates on this purchase order",
  "contractFlow.salesCcHint":
    "Search and select people to receive updates on this sales order",
});

// 手机端业务流程：三语只改变固定界面文案。
export const mobileWorkflow = Object.freeze({
  "orderForm.productPrice": "Product {number} price",
  "orderForm.enterRegistrationNumber": "Enter a business registration number",
  "orderForm.removeProduct": "Remove product {number}",
  "orderForm.taxNumber": "Tax number: {number}",
  "orderForm.personInCharge": "Person in charge: {name}",
  "orderForm.cannotDeselect": "This order cannot be deselected",
  "inspection.deselect": "Deselect",
  "contractReview.noFixedFlow": "The review workflow is unavailable",
  "preOrder.buy": "Buy",
  "preOrder.sell": "Sell",
  "contractReview.purchaseReviewTitle": "Review purchase contract",
  "contractReview.approvalInformation": "Approval information",
  "contractReview.downloadFailed": "Download failed",
  "contractReview.ccAlreadyAdded": "This CC recipient has already been added",
  "invoiceApproval.initiate": "Submit INV for approval",
  "invoiceApproval.review": "Review INV",
  "invoiceApproval.confirm": "Approve this INV?",
  "orderForm.nonNegative": "Enter a value greater than or equal to zero",
  "orderForm.selectBuyerCompany": "Select a buyer company",
  "contractReview.draftFailed": "Unable to load the contract draft",
  "orderFollow.businessTracking": "Business order tracking",
  "orderFollow.hideConfirm": "Hide this information?",
  "orderFollow.hidden": "Hidden successfully",
  "orderFollow.businessAcceptance": "Accept business orders",
  "preOrder.edit": "Edit purchase enquiry",
  "preOrder.updatedAwaitingPurchase":
    "Changes confirmed. Awaiting the purchase negotiator's confirmation.",
  "orderFollow.negotiatorAcceptance": "Accept negotiation orders",
  "orderFollow.hideLeadConfirm": "Hide this lead?",
  "preOrder.confirmPurchase": "Confirm purchase enquiry",
  "preOrder.purchaseTracking": "Purchase negotiation details",
  "preOrder.salesTracking": "Sales negotiation details",
  "inspection.outerPackaging": "Outer packaging",
  "inspection.middlePackaging": "Intermediate packaging",
  "inspection.minimumPackaging": "Smallest packaging",
  "inspection.productDetails": "Product details",
  "inspection.confirmDelete": "Confirm deletion",
  "inspection.completeConfirm": "This will complete the inspection. Continue?",
  "inspection.submitConfirm":
    "This will submit the inspection results. Continue?",
  "contractRoles.initiator": "Initiator",
  "contractRoles.selfReview": "Self review",
  "contractRoles.businessManager": "Business manager",
  "contractRoles.businessDirector": "Business director",
  "contractRoles.generalManager": "General manager",
  "contractRoles.negotiatorManager": "Negotiator manager",
  "contractReview.reviewAndCc": "Review and CC",
  "contractReview.noReviewers": "No reviewers",
  "contractReview.loadingCc": "Loading default CC recipients",
  "contractReview.reviewLevel": "Review level {level}",
  "contractReview.removeReviewer": "Remove {role}: {name}",
  "contractReview.keepReviewer": "Keep at least one review step",
  "contractReview.deleteReviewer": "Remove reviewer",
  "contractReview.removeCc": "Remove {name}",
  "purchasePayment.noApprovalFlow": "Payment approval workflow is unavailable",
  "purchasePayment.reviewerRemarkHint":
    "Enter review notes for this payment approval",
  "orderFollow.confirmMerge": "Confirm merge",
  "orderFollow.noAvailableOrders":
    "No orders are available yet. Please check again later.",
  "preOrder.enterPrice": "Enter the proposed price",
  "preOrder.quantity": "Proposed quantity",
  "preOrder.buyerCommissionRate": "Buyer commission rate",
  "preOrder.sellerCommissionRate": "Seller commission rate",
  "preOrder.enterCommissionRate": "Enter the commission rate",
  "preOrder.estimatedPayment": "Estimated payment:",
  "preOrder.usdSuffix": "USD;",
  "preOrder.cnySuffix": "CNY;",
  "preOrder.tradeNotes": "Transaction notes",
  "preOrder.enterTradeNotes": "Enter transaction notes",
  "preOrder.sellerContacts": "Seller contact details",
  "preOrder.buyerContacts": "Buyer contact details",
  "preOrder.buyerPrefix": "Buyer - ",
  "preOrder.buyerProviderPrefix": "Buyer information provider - ",
  "preOrder.confirm": "Confirm purchase enquiry",
  "preOrder.purchaseBusinessPrefix": "Purchase representative - ",
  "preOrder.buyerRolePrefix": "Buyer - ",
  "preOrder.clearSelection": "Clear selection",
  "orderDetails.sampleTitle": "DetailsAAA",
  "orderDetails.sampleNumber": "Order number A:",
  "preOrder.myEnquiries": "My purchase enquiries",
  "inspection.myInspections": "My inspections",
  "inspection.pending": "Awaiting inspection",
  "inspection.inspect": "Inspect",
  "inspection.chooseWarehouse": "Select a receiving warehouse",
  "inspection.chooseDate": "Select receipt date",
  "inspection.previousYear": "Previous year",
  "inspection.nextYear": "Next year",
  "inspection.clearDate": "Clear date",
  "outboundAudit.companyLookupHint": "Search by {field}",
  "tradeContract.installment": "Instalments",
  "tradeContract.fullPayment": "Full payment",
  "tradeContract.deleteFailed": "Unable to delete. Please try again.",
  "orderFollow.claimSuccess": "Order accepted",
  "orderFollow.contactSellerHint":
    "Order accepted. Contact the seller to confirm the supply details.",
  "orderFollow.contactBuyerHint":
    "Order accepted. Contact the buyer to confirm the purchase enquiry.",
  "orderFollow.awaitSalesHint":
    "Order accepted. Await acceptance by the sales representative.",
  "orderFollow.editContractHint":
    "Order accepted. Continue to edit the trade contract.",
  "orderFollow.backToFollow": "Back to order tracking",
  "externalPayment.amount": "Payment amount",
  "externalPayment.remainingTime": "Time left to pay",
  "externalPayment.confirm": "Confirm payment",
  "externalPayment.title": "External payment",
  "externalPayment.sellerAmount": "Seller payment amount",
  "externalPayment.sellerStatus": "Seller payment status",
  "externalPayment.copySellerLink": "Copy seller payment link",
  "externalPayment.buyerAmount": "Buyer payment amount",
  "externalPayment.buyerStatus": "Buyer payment status",
  "externalPayment.buyerTime": "Buyer payment time",
  "externalPayment.copyBuyerLink": "Copy buyer payment link",
  "outboundAudit.autoFillHint":
    "Filled after selecting a product and warehouse receipt",
  "outboundAudit.remarkPlaceholder":
    "Enter review notes (optional, up to 200 characters)",
  "outboundAudit.reloadRemarks": "Reload review notes",
  "outboundAudit.reloadCc": "Reload CC recipients",
  "outboundAudit.rejectTitle": "Reject dispatch order",
  "outboundAudit.rejectReasonRequired": "Enter a rejection reason (required)",
  "outboundAudit.resubmit": "Resubmit dispatch order for approval",
  "outboundAudit.initiateReview": "Submit dispatch order for review",
  "outboundAudit.initiateApproval": "Submit dispatch order for approval",
  "outboundAudit.resubmitConfirm": "Resubmit this dispatch order for approval?",
  "outboundAudit.submitConfirm": "Submit this dispatch order for approval?",
  "outboundAudit.approveConfirm": "Approve this dispatch order?",
  "outboundAudit.reviewConfirmFailed":
    "Unable to confirm approval. Please try again.",
  "outboundAudit.rejectConfirmFailed":
    "Unable to confirm rejection. Please try again.",
  "outboundAudit.relatedOrderFailed":
    "Unable to load the linked order. Go back and try again.",
  "outboundAudit.relatedDataFailed":
    "Unable to load linked dispatch data. Go back and try again.",
  "outboundAudit.contractDetailFailed": "Unable to load contract details",
  "outboundAudit.enterNewNumber": "Enter a new dispatch order number",
  "outboundAudit.newNumberRequired": "Enter a new dispatch order number different from the original",
  "outboundAudit.enterNumber": "Enter a dispatch order number",
  "outboundAudit.remarksLoading": "Loading review notes...",
  "outboundAudit.reviewersLoading": "Loading approvers...",
  "outboundAudit.noReviewers": "No approvers",
  "outboundAudit.noCc": "No CC recipients",
  "outboundAudit.rejectReasonLimit":
    "The rejection reason must be at most 200 characters",
  "outboundAudit.rejectReasonHint":
    "Enter a rejection reason (required, up to 200 characters)",
  "outboundAudit.productLabel": "Product {number}",
  "outboundAudit.collapseParty": "Collapse {party} information",
  "outboundAudit.expandParty": "View more {party} information",
  "orderFollow.myContracts": "Contracts I created",
  "orderFollow.trading": "In progress",
  "orderFollow.completed": "Completed",
  "orderFollow.awaitContractConfirmation":
    "Awaiting trade contract confirmation",
  "orderFollow.awaitSalesContract": "Awaiting trade contract from sales",
  "orderFollow.awaitContractCreation": "Awaiting trade contract creation",
  "orderFollow.contractCreated": "Trade contract created",
  "orderFollow.tradePrice": "Trade price",
  "orderFollow.tradeQuantity": "Trade quantity",
  "orderFollow.intermediateSellerCompany": "Intermediary seller company",
  "orderFollow.intermediateBuyerCompany": "Intermediary buyer company",
  "orderFollow.orderCreatedAt": "Order creation time",
  "orderFollow.sellerPrefix": "Seller - ",
  "orderFollow.purchaseNegotiatorPrefix": "Purchase negotiator - ",
  "orderFollow.salesNegotiatorPrefix": "Sales negotiator - ",
  "orderFollow.salesBusinessPrefix": "Sales representative - ",
  "orderFollow.supervisorPrefix": "Supervisor - ",
  "orderFollow.inspectorPrefix": "Inspector - ",
  "orderFollow.businessDetail": "Business order tracking details",
  "orderFollow.purchaseBusinessDetail": "Purchase tracking details",
  "orderFollow.salesBusinessDetail": "Sales tracking details",
  "tradeContract.enterUnitPrice": "Enter the product unit price",
  "tradeContract.enterQuantity": "Enter the product quantity",
  "tradeContract.enterTotal": "Enter the total amount",
  "tradeContract.sellerFee": "Seller transaction fee",
  "tradeContract.enterSellerFee": "Enter the seller transaction fee payable",
  "tradeContract.buyerFee": "Buyer transaction fee",
  "tradeContract.enterBuyerFee": "Enter the buyer transaction fee payable",
  "tradeContract.enterDeliveryDate": "Enter the delivery date",
  "tradeContract.uploadDocuments": "Upload contract documents",
  "tradeContract.enterAfterSalesTerms": "Enter the after-sales terms",
  "tradeContract.confirmed": "Contract confirmed",
});

export const workflowFeedback = Object.freeze({
  "workflowFeedback.sellerCompany": "Seller company",
  "workflowFeedback.buyerCompany": "Buyer company",
  "workflowFeedback.bankAccountName": "Bank account name",
  "workflowFeedback.noPurchases": "No purchase items available",
  "workflowFeedback.lockedPurchase": "This item cannot be deselected",
  "workflowFeedback.sameNegotiator": "The buyer and seller share a negotiator",
  "workflowFeedback.sameBusiness":
    "The buyer and seller share a business representative",
  "workflowFeedback.reviewPermissionMissing":
    "You do not have permission to review",
  "workflowFeedback.currentStage": "Current stage: ",
  "workflowFeedback.flowProgress": "Step {current} / {total}",
  "workflowFeedback.splitCount": "Number of orders",
  "workflowFeedback.allocateQuantities": "Allocate quantities",
  "workflowFeedback.allocationHint":
    "The quantities must add up to the total item quantity",
  "workflowFeedback.allocationComplete": "Fully allocated",
  "workflowFeedback.remainingQuantity": "Remaining: {quantity}",
  "workflowFeedback.selectablePeople": "Available {role}",
  "workflowFeedback.peopleCount": "{count} people",
  "workflowFeedback.personSearchGuide": "Search for {role} by name to add them",
  "workflowFeedback.ccSearchPlaceholder": "Search copied recipients by name",
  "workflowFeedback.noSelectableCc": "No copied recipients available",
  "workflowFeedback.paymentInformation": "Payment information",
  "workflowFeedback.buyerDetails": "Buyer details",
  "workflowFeedback.collapseSeller": "Hide seller details",
  "workflowFeedback.collapseBuyer": "Hide buyer details",
  "workflowFeedback.orderTotal": "Order total",
  "workflowFeedback.tradingParties": "Trading parties",
  "workflowFeedback.viewContract": "View contract",
  "workflowFeedback.quick": "Quick",
  "workflowFeedback.createTradeOrder": "Create trade order",
  "workflowFeedback.quickPurchaseOrder": "Quick purchase order",
  "workflowFeedback.blockInformation": "Hide this item",
  "workflowFeedback.claimOrder": "Claim order",
  "workflowFeedback.quickPurchaseContract": "Quick purchase contract",
  "workflowFeedback.goPay": "Pay now",
  "workflowFeedback.contractNumberPrefix": "Contract number: ",
  "workflowFeedback.goodsNumberPrefix": "Item number: ",
  "workflowFeedback.confirmTradeOrder": "Confirm trade order",
  "workflowFeedback.totalCny": "Total ¥",
  "workflowFeedback.acceptedAt": "Accepted: ",
  "workflowFeedback.supplyClueNegotiator": "Supply lead negotiator",
  "workflowFeedback.demandClueNegotiator": "Demand lead negotiator",
  "workflowFeedback.supplyGoodsNegotiator": "Supply item negotiator",
  "workflowFeedback.purchaseGoodsNegotiator": "Purchase item negotiator",
  "workflowFeedback.purchaseTradeNegotiator": "Purchase trade negotiator",
  "workflowFeedback.salesTradeNegotiator": "Sales trade negotiator",
  "workflowFeedback.informationPrice": "Listed price",
  "workflowFeedback.originalPricePrefix": "Original price: ",
  "workflowFeedback.buyerProviderPrefix": "Buyer information provider: ",
  "workflowFeedback.selectMultiple": "Select one or more",
  "workflowFeedback.reviewSucceeded": "{type} approved",
  "workflowFeedback.reviewRejected": "{type} rejected",
  "workflowFeedback.conditionLoadFailed":
    "Unable to load item conditions. Please try again later",
  "workflowFeedback.purchaseItemsUpdated": "Purchase items updated",
  "workflowFeedback.keepCurrentPurchase":
    "Keep at least the current purchase item",
  "workflowFeedback.negotiatorSearchFailed": "Negotiator search failed",
  "workflowFeedback.sellerReviewersLoadFailed":
    "Unable to load seller reviewers. Please try again later",
  "workflowFeedback.reviewersLoadFailed":
    "Unable to load reviewers. Please try again later",
  "workflowFeedback.ccSearchFailed": "Copied recipient search failed",
  "workflowFeedback.ccAdded": "Copied recipient added",
  "workflowFeedback.draftSaved": "Draft saved",
  "workflowFeedback.draftSaveFailed": "Unable to save the draft",
  "workflowFeedback.purchaseQuoteRequired":
    "Complete the purchase quotation first",
  "workflowFeedback.purchaseUnavailable":
    "A purchase order cannot be created for this item yet",
  "workflowFeedback.purchaseCreated": "Purchase order created",
  "workflowFeedback.createOrderFailed": "Unable to create the order",
  "workflowFeedback.purchaseQuoteSubmitted": "Purchase quotation submitted",
  "workflowFeedback.purchaseQuoteFailed":
    "Unable to submit the purchase quotation",
  "workflowFeedback.sellerFieldRequired": "Seller {field} is required",
  "workflowFeedback.buyerFieldRequired": "Buyer {field} is required",
  "workflowFeedback.newClaimInformation": "New orders available",
  "workflowFeedback.noClaimInformation": "No orders available to claim",
  "workflowFeedback.rejectFailed": "Unable to reject",
  "workflowFeedback.installmentIncomplete":
    "Enter the payment amount and date for {installment}",
  "workflowFeedback.installmentDateOrder":
    "The payment date for {current} cannot be before {previous}",
  "workflowFeedback.installmentProofRequired":
    "Upload payment proof for {installment}",
  "workflowFeedback.installmentCompanyRequired":
    "Select the ordering company for {installment}",
  "workflowFeedback.installmentBankRequired":
    "Select the payment bank for {installment}",
  "workflowFeedback.reviewFailed": "Unable to complete the review",
  "workflowFeedback.inspectionMissing": "Inspection data not found",
  "workflowFeedback.warehouseQuantityLimit":
    "The total received quantity cannot exceed {quantity}",
  "workflowFeedback.warehouseDeleteFailed":
    "Unable to delete the warehouse entry",
  "workflowFeedback.batchInspectionLoadFailed":
    "Unable to load batch inspection data",
  "workflowFeedback.confirmBatchInspection":
    "Submit inspection results for {count} items?",
  "workflowFeedback.batchInspectionSaveFailed":
    "Unable to save batch inspection results",
  "workflowFeedback.batchInspectionConfirmFailed":
    "Unable to confirm batch inspections",
  "workflowFeedback.batchInspectionRetry":
    "Unable to confirm batch inspections. Please try again later",
  "workflowFeedback.uploadingBeforeSave":
    "Images or videos are uploading. Please wait before saving",
  "workflowFeedback.loadingBeforeSave":
    "Data is loading. Please wait before saving",
  "workflowFeedback.inspectionSaveFailed": "Unable to save inspection results",
  "workflowFeedback.inspectionSaveRetry":
    "Unable to save inspection results. Please try again later",
  "workflowFeedback.inspectionConfirmRetry":
    "Unable to confirm the inspection. Please try again later",
  "workflowFeedback.rejectRefresh": "Unable to reject. Refresh and try again",
  "workflowFeedback.selectedGoodsCount":
    "Selected {selected} of {total} {item}",
  "workflowFeedback.viewPaymentReview": "View payment review",
  "workflowFeedback.viewPurchaseOrder": "View purchase order",
  "workflowFeedback.viewPurchaseContract": "View purchase contract",
  "workflowFeedback.purchaseGoodsRequired": "Select at least one purchase item",
  "workflowFeedback.purchaseGoodsFields":
    "Complete the required fields for item {index}",
});

export const sharedFlowUi = Object.freeze({
  "workflowFeedback.finalPayment": "Final payment",
  "workflowFeedback.buyerNotReceived":
    "* The sales buyer has not received the goods. Check carefully before confirming",
  "workflowFeedback.piProof": "PI invoice proof",
  "workflowFeedback.ciProof": "CI invoice proof",
  "workflowFeedback.paymentAuthorization": "Payment authorization",
  "workflowFeedback.invoiceUploadIntro": "Invoice upload instructions",
  "workflowFeedback.shippingEvidenceRequired":
    "Provide shipping proof or a shipping note",
  "workflowFeedback.shippingNotePlaceholder":
    "Delivery requirements, estimated arrival, or other notes (optional)",
  "workflowFeedback.invoiced": "Invoiced",
  "workflowFeedback.paymentEnded": "Ended",
  "workflowFeedback.totalReceivable": "Total receivable",
  "workflowFeedback.endPaymentHint":
    "Turn on when no further payment proof is needed for this order",
  "workflowFeedback.pendingOrderInformation":
    "Order information awaiting confirmation",
  "workflowFeedback.receiptSummary": "Receipt summary",
  "workflowFeedback.noPaymentProofHint":
    "No payment proof available. Verify receipt of funds with the buyer first",
  "workflowFeedback.notInvoiced": "Not invoiced",
  "workflowFeedback.paymentNotEnded": "Ongoing",
  "workflowFeedback.endPayment": "End payment collection for this order",
  "workflowFeedback.viewOrderNodes": "View order, contract, and payment stages",
  "workflowFeedback.checkOrderInformation":
    "Check item, payment, and invoice details",
  "workflowFeedback.viewProofHint": "Select a proof file to view its details",
  "workflowFeedback.logisticsInformation": "Shipping information",
  "workflowFeedback.logisticsNotes": "Shipping notes",
  "workflowFeedback.receiptConfirmHint":
    "Confirm only after the funds have arrived. The receipt will be recorded",
  "workflowFeedback.orderInvoiceProof": "Order invoice proof",
  "workflowFeedback.orderTotalAmount": "Total order amount",
  "workflowFeedback.requiredFields": "Complete the required fields",
  "workflowFeedback.addressRequired": "Add or change the delivery address",
  "workflowFeedback.paymentProofRequired": "Upload at least one payment proof",
  "workflowFeedback.paymentProofRequiredAlert":
    "Upload at least one payment proof",
  "workflowFeedback.logisticsCompanyRequired":
    "Enter the shipping company name",
  "workflowFeedback.invoiceCount":
    "{count} invoice files added. Ready to confirm upload",
  "workflowFeedback.invoiceRequired":
    "Add at least one invoice before confirming upload",
  "workflowFeedback.receiptCheckHint":
    "Check the goods and accompanying documents before confirming receipt",
  "workflowFeedback.notConfirmYet": "Not yet",
  "workflowFeedback.shippingIntro":
    "Enter shipping details so the buyer can track the shipment",
  "workflowFeedback.checkReceiptHint":
    "Check the order, amount received, and payment proof",
  "workflowFeedback.payerCompany": "Paying company (buyer)",
  "workflowFeedback.payeeCompany": "Receiving company (seller)",
  "workflowChat.agentManager": "Group managed by Chat Agent",
  "workflowChat.groupInitial": "G",
  "workflowChat.groupSettings": "Group settings ({count} members)",
  "workflowChat.privateChat": "Message",
  "workflowChat.mention": "Mention members",
  "workflowChat.mentionedMe": "Mentioned you",
  "workflowChatAgent.readOnly": "Read only",
  "workflowChat.agentName": "Group Agent",
  "workflowChat.purchaseOrderName": "Purchase ",
  "workflowChat.saleOrderName": "Sale ",
  "workflowChat.purchaseDraftName": "Purchase draft ",
  "workflowChat.saleDraftName": "Sales draft ",
  "workflowChat.orderCount": " ({count} orders)",
  "workflowChat.dateUnknown": "Date pending",
  "workflowChat.progress.DRAFT": "Not submitted",
  "workflowChat.progress.COMPLETED": "Completed",
  "workflowChat.progress.REJECTED": "Approval rejected",
  "workflowChat.progress.INVALID": "Order invalid",
  "workflowChat.progress.CLOSED": "Closed",
  "workflowChat.progress.WAITING_BUSINESS_CONFIRMATION": "Awaiting business confirmation",
  "workflowChat.progress.WAITING_PAYMENT": "Awaiting payment",
  "workflowChat.progress.WAITING_PAYMENT_PROOF": "Awaiting payment proof",
  "workflowChat.progress.WAITING_PAYMENT_CONFIRMATION": "Awaiting payment confirmation",
  "workflowChat.progress.WAITING_SHIPMENT": "Awaiting shipment",
  "workflowChat.progress.WAITING_RECEIPT": "Awaiting receipt",
  "workflowChat.progress.RECEIPT_CONFIRMED": "Receipt confirmed",
  "workflowChat.progress.REVIEW_APPROVED": "Review approved",
  "workflowChat.progress.OUTBOUND_REVIEW": "Outbound approval",
  "workflowChat.progress.OUTBOUND_REJECTED": "Outbound rejected",
  "workflowChat.progress.PROGRESS_UNAVAILABLE": "Progress pending",
  "workflowChat.progress.REVIEW_1": "Order approval",
  "workflowChat.progress.REVIEW_1_REJECTED": "Order approval rejected",
  "workflowChat.progress.REVIEW_2": "Contract approval",
  "workflowChat.progress.REVIEW_2_REJECTED": "Contract approval rejected",
  "workflowChat.progress.REVIEW_3": "Payment approval",
  "workflowChat.progress.REVIEW_3_REJECTED": "Payment approval rejected",
  "workflowChat.progress.REVIEW_4": "Payment terms approval",
  "workflowChat.progress.REVIEW_4_REJECTED": "Payment terms approval rejected",
  "workflowChat.progress.REVIEW_5": "Invoice approval",
  "workflowChat.progress.REVIEW_5_REJECTED": "Invoice approval rejected",
  "workflowChat.progress.REVIEW_6": "Shipping approval",
  "workflowChat.progress.REVIEW_6_REJECTED": "Shipping approval rejected",
  "workflowChat.fullChain": "Full workflow",
  "workflowChat.allMembers": "everyone",
  "workflowChat.draftUnavailable": "No saved draft was found. Save the draft and try again.",
  "workflowChat.scopeUnavailable": "The approval chain is not ready, or the payment installment is ambiguous.",
  "workflowChat.entry": "Workflow discussion",
  "workflowChat.title": "Workflow discussion group",
  "workflowChat.currentScope": "Current document workflow",
  "workflowChat.selectScope": "Select workflow",
  "workflowChat.active": "Active",
  "workflowChat.archived": "Archived",
  "workflowChat.cooling": "Post-completion discussion",
  "workflowChat.readonly": "Read-only archive",
  "workflowChat.round": "Round {number}",
  "workflowChat.unread": "{count} unread",
  "workflowChat.noArchived": "No archived discussions",
  "workflowChat.noActive": "No active discussions",
  "workflowChat.loadMoreGroups": "Load more groups",
  "workflowChat.archiveAt": "Becomes read-only at {time}",
  "workflowChat.memberCount": "Discussion members ({count})",
  "workflowChat.history": "Workflow chat history",
  "workflowChat.viewingReference": "Message #{number}",
  "workflowChat.laterMessages": "Later messages",
  "workflowChat.returnToChat": "Back to chat",
  "workflowChat.referenceUnavailable": "This referenced message is unavailable",
  "workflowChat.earlierMessages": "View earlier messages",
  "workflowChat.noMessages": "No discussion messages",
  "workflowChat.newMessages": "View new messages",
  "workflowChat.messagePlaceholder":
    "Discuss this workflow with its members. Enter to send; Shift+Enter for a new line",
  "workflowChat.archivedHint":
    "This discussion is archived. You can view its history",
  "workflowChat.participantsHint":
    "These workflow members will be included automatically:",
  "workflowChat.retentionHint":
    "Discussion stays open for 7 days after the workflow ends, then becomes read-only. Chat history is retained",
  "workflowChat.openingPlaceholder":
    "Explain why you are starting this discussion and what needs agreement",
  "workflowChat.start": "Start workflow discussion",
  "workflowChat.ccPermissionHint":
    "Copied recipients can join existing discussions. Only initiators and reviewers can create groups",
  "workflowChat.emptyHint":
    "Select a discussion from the list, or start one from a document review page",
  "workflowChat.roleSeparator": ", ",
  "workflowChat.orderApproval": "Order approval",
  "workflowChat.contractApproval": "Contract approval",
  "workflowChat.paymentApproval": "Payment approval",
  "workflowChat.paymentMethodApproval": "Payment method approval",
  "workflowChat.invoiceApproval": "Invoice approval",
  "workflowChat.outboundApproval": "Outbound approval",
  "workflowChat.discussion": "Workflow discussion",
  "workflowChat.scopeInstallment": "{scope} · Installment {number}",
  "workflowFeedback.installmentNumber": "Installment {number}",
});

// 移动端订单、合同及验货流程的增量显示文案。
export const mobileWorkflowFollowup = Object.freeze({
  "mobileOrderWorkflow.awaitSellerDualStamp": "Awaiting seller upload of dual-stamped contract",
  "mobileOrderWorkflow.awaitBuyerDualStamp": "Awaiting buyer upload of dual-stamped contract",
  "mobileOrderWorkflow.awaitBusinessDualStamp": "Awaiting business staff upload of dual-stamped contract",
  "mobileOrderWorkflow.awaitSellerStamp": "Awaiting seller upload of stamped contract",
  "mobileOrderWorkflow.awaitBuyerStamp": "Awaiting buyer upload of stamped contract",
  "mobileOrderWorkflow.paymentReviewUnderReview": "Payment workflow under review",
  "mobileOrderWorkflow.paymentReviewRejected": "Payment workflow rejected",
  "mobileOrderWorkflow.paymentMethodUnderReview": "Payment method under review",
  "mobileOrderWorkflow.paymentMethodRejected": "Payment method rejected",
  "mobileOrderWorkflow.invoiceUnderReview": "INV under review",
  "mobileOrderWorkflow.invoiceRejected": "INV rejected",
  "mobileOrderWorkflow.confirmInvoiceApproval": "Confirm INV approval",
  "mobileOrderWorkflow.viewInvoiceApproval": "View INV approval",
  "mobileOrderWorkflow.itemCountOne": "{count} item",
  "mobileOrderWorkflow.itemCountMany": "{count} items",
  "mobileOrderWorkflow.supportedFileTypes": "Multiple file types supported",
  "mobileOrderWorkflow.invoiceFile": "INV (commercial invoice)",
  "mobileOrderWorkflow.paymentReviewOpinion": "Enter your payment review comments",
  "mobileOrderWorkflow.noMergeableOrders": "No orders available to merge",
  "mobileOrderWorkflow.noOtherMergeableOrders": "No other orders are available to merge",
  "mobileOrderWorkflow.packagingImages": "Packaging images",
  "mobileOrderWorkflow.packagingVideos": "Packaging videos",
  "mobileOrderWorkflow.detailImages": "Detail images",
  "mobileOrderWorkflow.detailVideos": "Detail videos",
  "mobileOrderWorkflow.addShortVideo": "Add short video",
  "mobileOrderWorkflow.financeRole": "Finance",
  "mobileOrderWorkflow.salesContractNotSubmitted": "Sales contract not submitted",
  "mobileOrderWorkflow.buyerContractNotSubmitted": "Buyer contract not submitted",
  "mobileOrderWorkflow.sellerContractNotSubmitted": "Seller contract not submitted",
  "mobileOrderWorkflow.invoiceContractNotReviewed": "INV approval not started (contract not reviewed)",
  "mobileOrderWorkflow.orderAcceptedBy": "Order accepted by {name}",
  "mobileOrderWorkflow.awaitRoleReview": "Awaiting review by {role}",
  "mobileOrderWorkflow.purchaseOrderCreated": "Purchase order created",
  "mobileOrderWorkflow.purchaseOrderNotCreated": "Purchase order not created",
  "mobileOrderWorkflow.salesOrderCreated": "Sales order created",
  "mobileOrderWorkflow.salesOrderNotCreated": "Sales order not created",
  "mobileOrderWorkflow.purchaseContractSubmitted": "Purchase contract submitted",
  "mobileOrderWorkflow.purchaseContractNotSubmitted": "Purchase contract not submitted",
  "mobileOrderWorkflow.purchaseTemplateSubmitted": "Purchase contract template submitted",
  "mobileOrderWorkflow.salesContractSubmitted": "Sales contract submitted",
  "mobileOrderWorkflow.salesContractNotCreated": "Sales contract not created",
  "mobileOrderWorkflow.awaitSellerReview": "Awaiting seller review",
  "mobileOrderWorkflow.awaitBuyerReview": "Awaiting buyer review",
  "mobileOrderWorkflow.buyerReviewed": "Buyer reviewed",
  "mobileOrderWorkflow.awaitBusinessStamp": "Awaiting stamped contract upload",
  "mobileOrderWorkflow.awaitSellerProductLink": "Awaiting seller product link",
  "mobileOrderWorkflow.sellerProductLinked": "Seller product linked",
  "mobileOrderWorkflow.purchaseQuoted": "Purchase quotation submitted",
  "mobileOrderWorkflow.awaitBusinessInspection": "Awaiting business inspection",
  "mobileOrderWorkflow.awaitManagerInspection": "Awaiting manager inspection",
  "mobileOrderWorkflow.inspectionCompleted": "Inspection completed",
  "mobileOrderWorkflow.awaitDualStamp": "Awaiting dual-stamped contract",
  "mobileOrderWorkflow.dualStampUploaded": "Dual-stamped contract uploaded",
  "mobileOrderWorkflow.awaitPaymentProof": "Awaiting payment proof upload",
  "mobileOrderWorkflow.awaitPaymentProofConfirmation": "Awaiting payment proof confirmation",
  "mobileOrderWorkflow.paymentProofConfirmed": "Payment proof confirmed",
  "mobileOrderWorkflow.paymentReviewFlow": "Payment review workflow",
  "mobileOrderWorkflow.reviewPaymentWorkflow": "Review payment workflow",
  "mobileOrderWorkflow.sellerReceiptConfirmed": "Seller confirmed receipt of payment",
  "mobileOrderWorkflow.awaitBuyerPayment": "Awaiting buyer payment",
  "mobileOrderWorkflow.buyerPaid": "Buyer paid",
  "mobileOrderWorkflow.financeReceiptConfirmed": "Finance confirmed receipt",
  "mobileOrderWorkflow.customerReceived": "Customer received goods",
  "mobileOrderWorkflow.sellerShipped": "Seller shipped goods",
  "mobileOrderWorkflow.sellerNotShipped": "Seller has not shipped goods",
  "mobileOrderWorkflow.notShipped": "Not shipped",
  "mobileOrderWorkflow.reviewCompleted": "Review completed",
  "mobileOrderWorkflow.reviewRecordMissing": "Review record not created",
  "mobileOrderWorkflow.paymentReviewCompleted": "Payment review completed",
  "mobileOrderWorkflow.paymentReviewRecordMissing": "Payment review record not created",
  "mobileOrderWorkflow.paymentReviewNotStarted": "Payment review not started",
  "mobileOrderWorkflow.paymentMethodReviewed": "Payment method reviewed",
  "mobileOrderWorkflow.paymentMethodNotStarted": "Payment method approval not started",
  "mobileOrderWorkflow.invoiceReviewNotStarted": "INV approval not started",
  "mobileOrderWorkflow.invoiceNotStarted": "INV not started",
  "mobileOrderWorkflow.invoiceReviewed": "INV approval completed",
  "mobileOrderWorkflow.accountant": "Accountant",
  "mobileOrderWorkflow.cashier": "Cashier",
  "mobileOrderWorkflow.reviewPurchaseOrder": "Review purchase order",
  "mobileOrderWorkflow.confirmPurchaseOrder": "Confirm purchase order",
  "mobileOrderWorkflow.confirmContract": "Confirm contract",
  "mobileOrderWorkflow.confirmInvoice": "Confirm INV",
  "mobileOrderWorkflow.confirmPaymentApproval": "Confirm payment approval",
  "mobileOrderWorkflow.viewPaymentApproval": "View payment approval",
  "mobileOrderWorkflow.startPaymentMethodApproval": "Submit payment method for approval",
  "mobileOrderWorkflow.ownerNotReviewed": "Awaiting seller review",
  "mobileOrderWorkflow.ownerReviewed": "Seller reviewed",
  "mobileOrderWorkflow.paymentNotSubmitted": "Payment not submitted",
  "mobileOrderWorkflow.paymentUnderReview": "Payment under review",
  "mobileOrderWorkflow.paymentComplete": "Payment complete",
  "mobileOrderWorkflow.pendingPayment": "Awaiting payment",
  "mobileOrderWorkflow.paid": "Paid",
  "mobileOrderWorkflow.paying": "Payment in progress",
  "mobileOrderWorkflow.paymentFailed": "Payment failed",
  "mobileOrderWorkflow.purchasePaymentContract": "Purchase payment contract",
  "mobileOrderWorkflow.standardContract": "Standard contract",
  "mobileOrderWorkflow.approvalEnded": "Approval ended",
  "mobileOrderWorkflow.orderCompleted": "Order completed",
  "mobileOrderWorkflow.fillRemarks": "Enter remarks",
  "mobileOrderWorkflow.paymentUnavailable": "Payment information is temporarily unavailable",
  "mobileOrderWorkflow.networkRetry": "Network error. Please try again later",
  "mobileOrderWorkflow.initiateWithoutPi": "The supplier has not uploaded a PI. Submit payment for approval?",
  "mobileOrderWorkflow.initiatePaymentConfirmation": "Submit payment for approval?",
  "mobileOrderWorkflow.approveOrderConfirmation": "Approve this order?",
  "mobileOrderWorkflow.approveContractConfirmation": "Approve this contract?",
  "mobileOrderWorkflow.contractRelatedHint": "Select historical orders, contracts or payment reviews to link to this contract approval",
  "mobileOrderWorkflow.inspectionOrderLoading": "Loading order number",
  "mobileOrderWorkflow.inspectionGoodsRequired": "Product ID is missing. Return to the order and open this page again",
  "mobileOrderWorkflow.inspectionLoadFailed": "Unable to load the product",
  "mobileOrderWorkflow.inspectionStatusLoadFailed": "Unable to load inspection status",
  "mobileOrderWorkflow.inspectionRetry": "Unable to load. Please try again later",
  "mobileOrderWorkflow.inspectionReadFailed": "Unable to load inspection data",
  "mobileOrderWorkflow.inspectionSelectionMissing": "Selected product not found",
  "mobileOrderWorkflow.inspectionAttachment": "Inspection attachment",
  "mobileOrderWorkflow.inspectionProductLabel": "Product {number}",
  "mobileOrderWorkflow.warehouseUnified": "Applied to {count} other products",
  "mobileOrderWorkflow.inspectionBatchConfirmed": "Inspection confirmed for {count} products",
  "mobileOrderWorkflow.productDataLoadFailed": "Unable to load data for {name}",
  "mobileOrderWorkflow.productInspectionNotAllowed": "Inspection cannot be confirmed for {name} in its current state",
  "mobileOrderWorkflow.productApprovalRemarkRequired": "Approval remarks are required for {name}",
  "mobileOrderWorkflow.productWarehouseQuantityRequired": "Every received quantity for {name} must be greater than zero",
  "mobileOrderWorkflow.goodsRequiredInfo": "Required product information",
  "mobileOrderWorkflow.productRequiredInfo": "Required product information",
  "mobileOrderWorkflow.partiesRequiredInfo": "Required buyer and seller information",
  "mobileOrderWorkflow.reviewerInfo": "Reviewer information",
  "mobileOrderWorkflow.noProductProviders": "No product providers available",
  "mobileOrderWorkflow.buyerContactPhone": "Buyer contact number",
  "mobileOrderWorkflow.orderLoadFailed": "Unable to load order information",
  "mobileOrderWorkflow.purchaseAccessDenied": "This account cannot create purchase orders. Switch to a purchasing business account.",
  "mobileOrderWorkflow.orderLoadRetry": "Unable to load the order. Return to the home page and try again.",
  "mobileOrderWorkflow.goodsLoadFailed": "Unable to load product information",
  "mobileOrderWorkflow.draftSaved": "Draft saved",
  "mobileOrderWorkflow.salesMergedContract": "Create merged sales contract",
  "mobileOrderWorkflow.sellerProvider": "Seller information provider",
  "mobileOrderWorkflow.buyerProvider": "Buyer information provider",
  "mobileOrderWorkflow.deliveryNote": "Delivery note",
  "mobileOrderWorkflow.inspectGoodsLoadFailed": "Unable to load inspection products"
});

export const messages = Object.freeze({
  ...mobileWorkflowFollowup,
  ...sharedFlowUi,
  ...workflowFeedback,
  ...mobileWorkflow,
  "purchasePayment.supplierPiMissingApprovalConfirm":
    "The supplier has not uploaded a PI. Approve anyway?",
  "purchasePayment.approvalConfirm": "Approve this payment?",
  ...contractFlow,
  ...outboundList,
  ...buy,
  ...contact,
  ...broker,
  ...checkout,
  ...mobileComponents,
  ...mobile,
  ...mobileCart,
  ...mobileTransactions,
  ...details,
  ...desktopCart,
  ...contractReview,
  ...follow,
  ...desktopComponents,
  ...desktopTransactions,
  ...personal,
  ...split,
  "outboundAudit.priceUnit": "Price currency",
  "outboundAudit.goodsQuantity": "Order quantity",
  "outboundAudit.warehouseQuantity": "Warehouse quantity",
  "outboundAudit.stockQuantity": "Stock quantity",
});
